import { useDispatch } from 'react-redux'
import { useMutation } from '@apollo/client'
import { useParams } from 'react-router-dom'
import { ExclamationCircleFilled } from '@ant-design/icons'
import updateImDfmFeedbackInfoMutation, {
    updateImDfmFeedbackRefetchQuery,
} from '@Admin/AdminQuotingPage/ImDfmSlidesPanel/ImDfmSlide/ActiveSlide/updateImDfmFeedbackInfoMutation'
import { DFM_NO_ACTION_REQUIRED } from '@Admin/AdminQuotingPage/ImDfmSlidesPanel/ImDfmSlide/constants'

import Box from '~/core/Box'
import Button from '~/core/Button'
import getColor from '~/lib/getColor'
import logger from '~/lib/logger'
import { actions as ImDfmActions } from '~/redux-modules/im-dfm'

const PLACEMENT = 'reset-slide-popover'
const RESET_SLIDE_POPOVER_DESCRIPTION =
    'Are you sure you want to Reset this status? This action cannot be undone.'

type ParamsType = {
    id?: string
}

type ConfirmResetPopoverContentType = {
    dfmFeedbackId?: string | null
    togglePopover: () => void
}

const ConfirmResetPopoverContent = (props: ConfirmResetPopoverContentType) => {
    const { dfmFeedbackId, togglePopover } = props

    const dispatch = useDispatch()
    const { id } = useParams<ParamsType>()

    const [updateImDfmFeedbackInfo] = useMutation(
        updateImDfmFeedbackInfoMutation,
    )

    const resetDfmSlide = async (evt: Event) => {
        evt.stopPropagation()
        togglePopover()

        try {
            const result = await updateImDfmFeedbackInfo({
                variables: {
                    dfmFeedbackId,
                    status: DFM_NO_ACTION_REQUIRED,
                },
                refetchQueries: [
                    {
                        query: updateImDfmFeedbackRefetchQuery,
                        variables: {
                            id,
                        },
                    },
                ],
            })

            dispatch(
                ImDfmActions.updateImDfmSlide(
                    result?.data?.updateDfmFeedbackInfo,
                ),
            )
        } catch (err) {
            logger.exception(err, {
                extra: {
                    info: 'ConfirmResetPopoverContent::Failed to reset status with updateDfmFeedbackInfo mutation',
                    qmrId: id,
                    dfmFeedbackId,
                    status,
                },
            })
        }
    }

    return (
        <>
            <Box>
                <ExclamationCircleFilled
                    style={{
                        color: getColor('warning6'),
                        fontSize: '14px',
                        margin: '4px 12px 0 0',
                    }}
                />
                <Box height="55px" width="270px">
                    {RESET_SLIDE_POPOVER_DESCRIPTION}
                </Box>
            </Box>
            <Box marginTop="8px" justifyContent="end">
                <Button
                    data-test-target="close-popover"
                    name="cancel-reset-slide"
                    onClick={togglePopover}
                    placement={`${PLACEMENT}-close`}
                    size="small"
                    style={{
                        fontWeight: 400,
                        marginRight: '4px',
                    }}
                >
                    Cancel
                </Button>
                <Button
                    data-test-target="reset-slide"
                    onClick={resetDfmSlide}
                    name="reset-slide"
                    placement={`${PLACEMENT}-selected`}
                    size="small"
                    style={{ fontWeight: 400 }}
                    type="danger"
                >
                    Reset status
                </Button>
            </Box>
        </>
    )
}

export default ConfirmResetPopoverContent
